import { motion, useInView, AnimatePresence } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ImageGalleryModal } from "@/components/ImageGalleryModal";
import { Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

interface Project {
  id: string;
  title: string;
  category: string;
  image: string;
  description: string;
}

const allProjects: Project[] = [
  {
    id: "1",
    title: "LinkedIn Authority Series",
    category: "Carousel Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2F9d6ca155b4324b47bc06b1faa9b1e958?format=webp&width=800",
    description: "Eye-catching carousel posts that boost engagement and tell your brand story",
  },
  {
    id: "2",
    title: "Clarity Framework Carousel",
    category: "Carousel Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2Ffa048135e8a94f5b8a6f306b2ca59b64?format=webp&width=800",
    description: "6-part carousel series for building audience trust and engagement",
  },
  {
    id: "3",
    title: "Premium Audio Poster",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2Fba7220b3481f41819efb333c298ef8a0?format=webp&width=800",
    description: "Striking poster design for premium headphones with bold typography and visual hierarchy",
  },
  {
    id: "4",
    title: "Smart Watch Campaign Poster",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2F2495fd633b5a4f07a07bbc145822b1a6?format=webp&width=800",
    description: "Modern tech product poster that communicates features and drives engagement",
  },
  {
    id: "5",
    title: "AI Clarity Strategy",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2F54a16f38b7804286bbd39d3c7ed9a7e4?format=webp&width=800",
    description: "Modern branding strategy highlighting AI clarity and competitive advantages",
  },
  {
    id: "6",
    title: "AI Marketing Revolution",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2F6be6338d1ad542c4a0290a4cb43a2e29?format=webp&width=800",
    description: "Strategic branding design showcasing AI marketing innovations and capabilities",
  },
  {
    id: "7",
    title: "Smart Automation System",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2Fdaa94588eb2149e1b5f0acd2381fce77?format=webp&width=800",
    description: "Complete branding design for AI-powered automation and smart systems",
  },
  {
    id: "8",
    title: "Startup Growth Strategy",
    category: "Brand Revamping",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2F2b3bd52bb98f4f06980cb6e8252c9614?format=webp&width=800",
    description: "Fresh brand transformation for startup businesses focusing on growth and scaling",
  },
  {
    id: "9",
    title: "Digital Marketing Excellence",
    category: "Brand Revamping",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2Fc0c9e4c786334ca594b23937fd0fe575?format=webp&width=800",
    description: "Modern brand revamp showcasing digital marketing strategies and expertise",
  },
  {
    id: "10",
    title: "Link Building & SEO Success",
    category: "Brand Revamping",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2F29f2584adefd4e51b4a0d7921d85c5a9?format=webp&width=800",
    description: "Strategic brand redesign for SEO and link building services with proven results",
  },
  {
    id: "11",
    title: "Workflow Automation for Tech",
    category: "Brand Revamping",
    image: "https://cdn.builder.io/api/v1/image/assets%2F8cc4a5e6052f4f32a4ca6363930538b9%2Fb059e93e7a404851b6607172d86356a8?format=webp&width=800",
    description: "Complete brand overhaul for tech-focused workflow automation solutions",
  },
  {
    id: "12",
    title: "Strategic Brand Design",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fc914f39f7d3643d497e8fc06c630e203?format=webp&width=800",
    description: "Comprehensive brand strategy rooted in design thinking and consumer psychology",
  },
  {
    id: "13",
    title: "Professional Brand Strategy",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F846b77d43920489081c929ce941921a9?format=webp&width=800",
    description: "Strategic design framework for building trust and market leadership",
  },
  {
    id: "14",
    title: "Digital Profile Enhancement",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F06ed7ede28e04d6c8fac238962a2e54b?format=webp&width=800",
    description: "Personal branding and profile design for professional growth",
  },
  {
    id: "15",
    title: "User Experience Strategy",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fbc6c7943c6f64e0fa9dc493d01e431a7?format=webp&width=800",
    description: "Design focused on user experience that drives product success and engagement",
  },
  {
    id: "16",
    title: "Growth-Focused Brand Strategy",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fad6b2baf1c2f4708abdb482657a93c8a?format=webp&width=800",
    description: "Comprehensive brand strategy for sustainable business growth and scaling",
  },
  {
    id: "17",
    title: "Pure Essence Logo Package",
    category: "Logo Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F7263076ee3ff4e1bad9eb239ef8a9d53?format=webp&width=800",
    description: "Complete logo and packaging design for natural skincare brand with elegant branding",
  },
  {
    id: "18",
    title: "Naturaé Skincare Identity",
    category: "Logo Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F46a4762aa3544a8a9b5e5851199df9fa?format=webp&width=800",
    description: "Minimalist logo and brand identity for organic skincare company",
  },
  {
    id: "19",
    title: "Café Bloom Logo Design",
    category: "Logo Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fd9e583ab0abd44dcae2153af73914b26?format=webp&width=800",
    description: "Elegant coffee brand logo with botanical elements and premium packaging design",
  },
  {
    id: "20",
    title: "Matcha Fusion Campaign",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fbb43f608a8f846799946c647e0dc366c?format=webp&width=800",
    description: "Vibrant matcha drink poster with engaging typography and promotional messaging",
  },
  {
    id: "21",
    title: "Nike Flyknit Launch",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F6bbd8ce3948948d6bc165bbe6c906ea5?format=webp&width=800",
    description: "Dynamic footwear campaign poster showcasing product features and brand identity",
  },
  {
    id: "22",
    title: "Clarity Framework Series",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F758482b194b34d37bdea1b22de07d7b7?format=webp&width=800",
    description: "6-part clarity and communication framework poster series for thought leadership",
  },
  {
    id: "23",
    title: "Blueberry Blast Beverage",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F621cdb0b8f6d4ec99249762657353eda?format=webp&width=800",
    description: "Refreshing beverage poster with appetizing product photography and bold design",
  },
  {
    id: "24",
    title: "Premium Airpods Campaign",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fe72615a806f04b5a8eb89918871984dc?format=webp&width=800",
    description: "Modern wireless earbuds poster emphasizing quality and user experience",
  },
  {
    id: "25",
    title: "Smartech AI Marketing",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F9045f8ea99a64e4e827e1c002e8ea1cf?format=webp&width=800",
    description: "Innovative AI marketing solutions poster highlighting competitive advantages",
  },
  {
    id: "26",
    title: "AI Clarity Intelligence",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fcf3c0dfda619432ab2d49aed83095b29?format=webp&width=800",
    description: "Strategic AI and clarity positioning poster for tech-forward businesses",
  },
  {
    id: "27",
    title: "Multicia Gadget Store",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fc1bd3ac381ac42a2b7cbf1fa470879fc?format=webp&width=800",
    description: "Electronics and accessories store poster with product showcase and contact details",
  },
  {
    id: "28",
    title: "Multicia Services Showcase",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fc206152332b044d2bc9f0575a67ff8eb?format=webp&width=800",
    description: "Tech services and support poster highlighting comprehensive offerings",
  },
  {
    id: "29",
    title: "Lune Coffee Premium",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fc73ac7bb85bb45e4b7f23bc64a1f3a30?format=webp&width=800",
    description: "Premium coffee brand poster showcasing quality and taste appeal",
  },
  {
    id: "30",
    title: "New Branding Campaign",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fc7b631b481974140a707f3f4379d251c?format=webp&width=800",
    description: "Brand transformation and rebranding campaign announcement poster",
  },
  {
    id: "31",
    title: "Premium Headphones",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fbacea570326d4513b00d0be9bef024fa?format=webp&width=800",
    description: "High-fidelity audio headphones poster emphasizing sound quality and design",
  },
  {
    id: "32",
    title: "Matcha Enjoy Moment",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F485a0045013b40b892825b841ba79eba?format=webp&width=800",
    description: "Lifestyle matcha poster capturing moments of relaxation and enjoyment",
  },
  {
    id: "33",
    title: "Smartech Work Smarter AI",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fb5a57846aba64c23831b673cf3b4c914?format=webp&width=800",
    description: "AI automation and productivity solutions poster for businesses",
  },
  {
    id: "34",
    title: "Monthly Client Feedback",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fba02c91e33764cad9aa0bdd61c568b1f?format=webp&width=800",
    description: "Client satisfaction and metrics poster displaying performance analytics",
  },
  {
    id: "35",
    title: "Rumah Siddiqi Branding",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F0c4147cd031d410a9d571cf0fc2d62e0?format=webp&width=800",
    description: "Professional personal branding poster for digital presence and portfolio",
  },
  {
    id: "36",
    title: "Adrian & Gourmet Morgana Wedding",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F994aa18119d0469ab260eb8952db745b?format=webp&width=800",
    description: "Elegant wedding invitation poster with floral design and celebration details",
  },
  {
    id: "37",
    title: "Glominize Skincare Line",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fb5622f4aec034f159547cc97b11bc0cd?format=webp&width=800",
    description: "Premium skincare product benefits poster highlighting hydration and radiance",
  },
  {
    id: "38",
    title: "Build Authority on LinkedIn",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fcb8ebcf1807f47fc9e92b1a8d280a606?format=webp&width=800",
    description: "Professional authority and LinkedIn growth strategy poster with engaging visuals",
  },
  {
    id: "39",
    title: "Your Favorite Matcha Tea",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2Fa4d005d2f3dc42268360334f874563f2?format=webp&width=800",
    description: "Premium matcha beverage poster emphasizing quality and healthy lifestyle",
  },
  {
    id: "40",
    title: "Premium Audio Airpods Pro",
    category: "Poster Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2Feedf44d47db24a07942816f2f4798218%2F6a622c1bba80455186136751ded5b687?format=webp&width=800",
    description: "High-end wireless earbuds poster showcasing premium sound quality and features",
  },
  {
    id: "41",
    title: "Fitness Club Branding",
    category: "Brand Design",
    image: "https://cdn.builder.io/api/v1/image/assets%2F001163b9bdd54d51be26ccacddbfd843%2Fcd1f6e9426034b31b1f4ccc49a4cc7f7?format=webp&width=800",
    description: "Complete brand identity system for fitness club including logo, color palette, and typography guidelines",
  },
];

const categories = Array.from(new Set(allProjects.map((p) => p.category)));

const BehanceIcon = () => (
  <svg viewBox="0 0 128 128" fill="currentColor" className="w-4 h-4">
    <rect width="128" height="128" fill="currentColor" rx="8"/>
    <g fill="white" fontFamily="Arial, sans-serif" fontSize="90" fontWeight="bold" textAnchor="middle" dominantBaseline="middle">
      <text x="64" y="70">Bé</text>
    </g>
  </svg>
);

const ProjectsHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/#about" },
    { name: "Services", href: "/#services" },
    { name: "Portfolio", href: "/" },
    { name: "Testimonials", href: "/#testimonials" },
  ];

  const handleNavClick = (href: string) => {
    setIsMobileMenuOpen(false);

    if (href === "/") {
      navigate("/");
    } else if (href.startsWith("/#")) {
      navigate("/");
      setTimeout(() => {
        const section = href.substring(2);
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? "bg-background/90 backdrop-blur-xl border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 sm:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1.5 sm:gap-2"
          >
            <span className="text-xl sm:text-2xl font-display font-bold text-gradient-blue">Atika</span>
            <span className="text-xl sm:text-2xl font-display font-light text-foreground">Vision</span>
            <motion.span
              className="text-primary text-xl sm:text-2xl"
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
            >
              💙
            </motion.span>
          </button>

          <nav className="hidden lg:flex items-center gap-6 xl:gap-8 absolute left-1/2 -translate-x-1/2">
            {navLinks.map((link) => (
              <motion.button
                key={link.name}
                onClick={() => handleNavClick(link.href)}
                className="text-muted-foreground hover:text-primary transition-colors duration-300 font-medium"
                whileHover={{ y: -2 }}
              >
                {link.name}
              </motion.button>
            ))}
          </nav>

          <motion.div
            className="hidden lg:block"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6 }}
          >
            <a href="https://wa.me/923220967040?text=Hi%20Atika%2C%20I%20would%20like%20to%20discuss%20my%20branding%20project%20with%20you." target="_blank" rel="noopener noreferrer">
              <Button variant="hero" size="lg">
                Let's Talk
              </Button>
            </a>
          </motion.div>

          <motion.button
            className="lg:hidden text-foreground p-2 rounded-lg hover:bg-secondary transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            whileTap={{ scale: 0.9 }}
          >
            <AnimatePresence mode="wait">
              {isMobileMenuOpen ? (
                <motion.div key="close" initial={{ rotate: -90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }} exit={{ rotate: 90, opacity: 0 }} transition={{ duration: 0.2 }}>
                  <X size={24} />
                </motion.div>
              ) : (
                <motion.div key="menu" initial={{ rotate: 90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }} exit={{ rotate: -90, opacity: 0 }} transition={{ duration: 0.2 }}>
                  <Menu size={24} />
                </motion.div>
              )}
            </AnimatePresence>
          </motion.button>
        </div>
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="lg:hidden bg-background/98 backdrop-blur-xl border-b border-border overflow-hidden"
          >
            <nav className="container mx-auto px-6 sm:px-8 py-6 flex flex-col gap-2">
              {navLinks.map((link) => (
                <motion.button
                  key={link.name}
                  onClick={() => handleNavClick(link.href)}
                  className="transition-all duration-300 font-medium text-lg py-3 px-4 rounded-xl text-left text-muted-foreground hover:text-primary hover:bg-secondary/50"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {link.name}
                </motion.button>
              ))}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="mt-4"
              >
                <a href="https://wa.me/923220967040?text=Hi%20Atika%2C%20I%20would%20like%20to%20discuss%20my%20branding%20project%20with%20you." target="_blank" rel="noopener noreferrer" className="w-full">
                  <Button variant="hero" size="lg" className="w-full">
                    Let's Talk
                  </Button>
                </a>
              </motion.div>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

const ProjectsFooter = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const socialLinks = [
    { icon: Linkedin, href: "https://www.linkedin.com/in/atika-vision/", label: "LinkedIn" },
    { icon: BehanceIcon, href: "https://www.behance.net/atikavisio-n", label: "Behance" },
    { icon: () => <FontAwesomeIcon icon={faWhatsapp} className="w-4 h-4" />, href: "https://wa.me/923220967040?text=Hi%20Atika%2C%20I%20would%20like%20to%20discuss%20my%20branding%20project%20with%20you.", label: "WhatsApp" },
  ];

  const quickLinks = [
    { label: "About", href: "/#about" },
    { label: "Services", href: "/#services" },
    { label: "Portfolio", href: "/" },
    { label: "Testimonials", href: "/#testimonials" },
    { label: "FAQ", href: "/#faq" },
  ];

  const handleLinkClick = (href: string) => {
    if (href === "/") {
      navigate("/");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (href.startsWith("/#")) {
      navigate("/");
      setTimeout(() => {
        const section = href.substring(2);
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 300);
    }
  };

  return (
    <footer className="relative bg-secondary/30 border-t border-border">
      <div className="container mx-auto px-6 sm:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <motion.button
              onClick={() => navigate("/")}
              className="flex items-center gap-1.5 sm:gap-2 mb-4"
            >
              <span className="text-xl sm:text-2xl font-bricolage font-bold text-gradient-blue">Atika</span>
              <span className="text-xl sm:text-2xl font-bricolage font-light text-foreground">Vision</span>
              <span className="text-primary text-xl sm:text-2xl">💙</span>
            </motion.button>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6 max-w-xs">
              Creating brand identities that remove buyer hesitation and convert visitors into loyal clients.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300"
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <social.icon className="w-4 h-4" />
                </motion.a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bricolage font-semibold text-foreground mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleLinkClick(link.href)}
                    className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bricolage font-semibold text-foreground mb-4">Services</h4>
            <ul className="space-y-3">
              {["Brand Identity", "Logo Design", "Visual Strategy", "Brand Guidelines"].map((service) => (
                <li key={service}>
                  <button
                    onClick={() => handleLinkClick("/#services")}
                    className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bricolage font-semibold text-foreground mb-4">Get In Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                <a href="mailto:atikavision@gmail.com" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  atikavision@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                <a href="tel:+923220967040" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  +92 322 0967040
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground text-sm">Pakistan</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container mx-auto px-6 sm:px-8 py-6">
          <div className="flex items-center justify-center">
            <motion.div className="text-muted-foreground text-xs sm:text-sm text-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
              © {currentYear} Atika Vision. Made by <span className="text-foreground font-medium">Ali Hassan</span>
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const Projects = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const navigate = useNavigate();
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [currentCategory, setCurrentCategory] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <ProjectsHeader />
      <main>
        {/* Page Header */}
        <section className="py-16 sm:py-24 md:py-32 bg-secondary/20">
          <div className="container mx-auto px-6 sm:px-8">
            <motion.button
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/");
              }}
              className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors mb-8 font-medium cursor-pointer"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              whileHover={{ x: -4 }}
              whileTap={{ scale: 0.95 }}
            >
              <ArrowUpRight className="w-5 h-5 rotate-180 text-primary" />
              <span className="text-primary">Back</span>
            </motion.button>
            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span className="text-primary font-medium uppercase tracking-wider text-xs sm:text-sm">
                Portfolio
              </span>
              <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold mt-4 sm:mt-6 mb-6 sm:mb-8">
                All <span className="text-gradient-blue">Projects</span>
              </h1>
              <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto px-2">
                Explore our complete collection of brand identities and design solutions crafted for ambitious
                businesses.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Projects by Category */}
        <section className="py-16 sm:py-24 md:py-32" ref={ref}>
          {categories.map((category, categoryIndex) => (
            <div key={category}>
              {category === "Brand Revamping" ? (
                <div className="mb-16 sm:mb-24">
                  <div className="container mx-auto px-6 sm:px-8 mb-8 sm:mb-12">
                    <motion.div
                      initial={{ opacity: 0, y: 50 }}
                      animate={isInView ? { opacity: 1, y: 0 } : {}}
                      transition={{ duration: 0.6, delay: categoryIndex * 0.2 }}
                    >
                      <motion.div
                        className="mb-8 sm:mb-12"
                        initial={{ opacity: 0, x: -30 }}
                        animate={isInView ? { opacity: 1, x: 0 } : {}}
                        transition={{ duration: 0.6, delay: categoryIndex * 0.2 + 0.1 }}
                      >
                        <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold">
                          {category}
                        </h2>
                        <div className="w-12 h-1 bg-primary mt-3 rounded-full" />
                      </motion.div>
                    </motion.div>
                  </div>
                  <div className="container mx-auto px-6 sm:px-8">
                    <div className="flex flex-col gap-6 sm:gap-8">
                      {allProjects
                        .filter((project) => project.category === category)
                        .map((project, index) => {
                          const categoryProjects = allProjects.filter(p => p.category === category);
                          const projectIndexInCategory = categoryProjects.findIndex(p => p.id === project.id);
                          return (
                        <motion.div
                          key={project.id}
                          initial={{ opacity: 0, y: 30 }}
                          animate={isInView ? { opacity: 1, y: 0 } : {}}
                          transition={{
                            duration: 0.6,
                            delay: categoryIndex * 0.2 + 0.15 + index * 0.1,
                          }}
                          className="group relative rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer w-full"
                          whileHover={{ y: -10 }}
                          onClick={() => {
                            setCurrentCategory(category);
                            setSelectedImageIndex(projectIndexInCategory);
                            setIsGalleryOpen(true);
                          }}
                        >
                          <div className="w-full" style={{ aspectRatio: "1584 / 396" }}>
                            <motion.img
                              src={project.image}
                              alt={project.title}
                              loading="lazy"
                              decoding="async"
                              className="w-full h-full object-cover"
                              whileHover={{ scale: 1.1 }}
                              transition={{ duration: 0.6 }}
                            />
                          </div>

                          <motion.div
                            className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent"
                            initial={{ opacity: 0 }}
                            whileHover={{ opacity: 1 }}
                            transition={{ duration: 0.3 }}
                          />

                          <motion.div
                            className="absolute bottom-0 left-0 right-0 p-4 sm:p-6"
                            initial={{ y: 20, opacity: 0 }}
                            whileHover={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.3 }}
                          >
                            <h3 className="font-display text-lg sm:text-xl font-semibold mt-1 flex items-center justify-start gap-2">
                              {project.title}
                              <motion.div
                                className="flex items-center justify-center shrink-0"
                                initial={{ x: -5, opacity: 0 }}
                                whileHover={{ x: 0, opacity: 1 }}
                              >
                                <ArrowUpRight className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                              </motion.div>
                            </h3>
                            <p className="text-muted-foreground text-sm mt-2">{project.description}</p>
                          </motion.div>

                          <motion.div
                            className="absolute inset-0 rounded-xl sm:rounded-2xl border-2 border-transparent"
                            whileHover={{ borderColor: "hsl(210 100% 55% / 0.5)" }}
                            transition={{ duration: 0.3 }}
                          />
                        </motion.div>
                      );
                        })}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="container mx-auto px-6 sm:px-8 mb-16 sm:mb-24">
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6, delay: categoryIndex * 0.2 }}
                  >
                    <motion.div
                      className="mb-8 sm:mb-12"
                      initial={{ opacity: 0, x: -30 }}
                      animate={isInView ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.6, delay: categoryIndex * 0.2 + 0.1 }}
                    >
                      <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold">
                        {category}
                      </h2>
                      <div className="w-12 h-1 bg-primary mt-3 rounded-full" />
                    </motion.div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
                      {allProjects
                        .filter((project) => project.category === category)
                        .map((project, index) => {
                          const categoryProjects = allProjects.filter(p => p.category === category);
                          const projectIndexInCategory = categoryProjects.findIndex(p => p.id === project.id);
                          return (
                          <motion.div
                            key={project.id}
                            initial={{ opacity: 0, y: 30 }}
                            animate={isInView ? { opacity: 1, y: 0 } : {}}
                            transition={{
                              duration: 0.6,
                              delay: categoryIndex * 0.2 + 0.15 + index * 0.1,
                            }}
                            className="group relative rounded-lg sm:rounded-xl overflow-hidden cursor-pointer"
                            whileHover={{ y: -10 }}
                            onClick={() => {
                              setCurrentCategory(category);
                              setSelectedImageIndex(projectIndexInCategory);
                              setIsGalleryOpen(true);
                            }}
                          >
                            <div className="aspect-square overflow-hidden">
                              <motion.img
                                src={project.image}
                                alt={project.title}
                                loading="lazy"
                                decoding="async"
                                className="w-full h-full object-cover"
                                whileHover={{ scale: 1.1 }}
                                transition={{ duration: 0.6 }}
                              />
                            </div>

                            <motion.div
                              className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent"
                              initial={{ opacity: 0 }}
                              whileHover={{ opacity: 1 }}
                              transition={{ duration: 0.3 }}
                            />

                            <motion.div
                              className="absolute bottom-0 left-0 right-0 p-4 sm:p-6"
                              initial={{ y: 20, opacity: 0 }}
                              whileHover={{ y: 0, opacity: 1 }}
                              transition={{ duration: 0.3 }}
                            >
                              <h3 className="font-display text-lg sm:text-xl font-semibold mt-1 flex items-center justify-start gap-2">
                                {project.title}
                                <motion.div
                                className="flex items-center justify-center shrink-0"
                                initial={{ x: -5, opacity: 0 }}
                                whileHover={{ x: 0, opacity: 1 }}
                              >
                                <ArrowUpRight className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                                </motion.div>
                              </h3>
                              <p className="text-muted-foreground text-sm mt-2">{project.description}</p>
                            </motion.div>

                            <motion.div
                              className="absolute inset-0 rounded-xl sm:rounded-2xl border-2 border-transparent"
                              whileHover={{ borderColor: "hsl(210 100% 55% / 0.5)" }}
                              transition={{ duration: 0.3 }}
                            />
                          </motion.div>
                        );
                        })}
                    </div>
                  </motion.div>
                </div>
              )}
            </div>
          ))}
        </section>

        {/* CTA Section */}
        <section className="py-12 sm:py-16 md:py-20">
          <div className="container mx-auto px-6 sm:px-8">
            <motion.div
              className="relative overflow-hidden bg-gradient-to-br from-primary/15 via-background/80 to-secondary/20 border border-primary/20 rounded-2xl sm:rounded-3xl p-6 sm:p-10 md:p-16"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true, margin: "-100px" }}
              whileHover={{ borderColor: "hsl(210 100% 55% / 0.4)" }}
            >
              {/* Background decorative elements */}
              <div className="absolute inset-0 opacity-20 pointer-events-none">
                <div className="absolute top-0 right-0 w-96 h-96 bg-primary rounded-full blur-3xl" />
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-blue rounded-full blur-3xl" />
              </div>

              <div className="relative z-10 text-center">
                <motion.h2
                  className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                  viewport={{ once: true }}
                >
                  Ready to <span className="text-gradient-blue">Transform</span> Your Brand?
                </motion.h2>
                <motion.p
                  className="text-muted-foreground text-base sm:text-lg mb-10 sm:mb-12 max-w-2xl mx-auto"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  Let's create a brand identity that captures your vision and resonates with your audience. Get in touch today to discuss your project.
                </motion.p>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="inline-block"
                >
                  <a href="https://forms.gle/5romGYrTtiPbxcxf6" target="_blank" rel="noopener noreferrer">
                    <Button variant="hero" size="lg" className="group">
                      Start Your Project
                      <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </Button>
                  </a>
                </motion.div>
              </div>

              {/* Card border glow effect on hover */}
              <motion.div
                className="absolute inset-0 rounded-2xl sm:rounded-3xl border border-primary/0 pointer-events-none"
                whileInView={{ borderColor: "hsl(210 100% 55% / 0.3)" }}
                transition={{ duration: 0.3 }}
              />
            </motion.div>
          </div>
        </section>
      </main>
      <ProjectsFooter />

      {/* Image Gallery Modal */}
      <ImageGalleryModal
        isOpen={isGalleryOpen}
        images={currentCategory ? allProjects.filter(p => p.category === currentCategory) : allProjects}
        currentIndex={selectedImageIndex}
        onClose={() => setIsGalleryOpen(false)}
        onNavigate={setSelectedImageIndex}
      />
    </div>
  );
};

export default Projects;
